import http from "../config/axios";
import qs from "qs";

async function loginUser({ email, password }: { email: string, password: string }) {
    console.log('email', email);
    console.log('password', password);

    const formData = qs.stringify({
        username: email,
        password: password
    });
    console.log('formData', formData);

    try {
        const res = await http.request({
            method: "POST",
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            data: formData,
            url: "/auth/login_user",
        });
        const userId = res.data.user_id;
        if (!userId) {
            throw new Error("User ID não encontrado na resposta.");
        }

        localStorage.setItem("token", res.data["access_token"]);
        localStorage.setItem("refresh_token", res.data["refresh_token"]);

        return {
            auth_token: res.data["access_token"],
            refresh_token: res.data["refresh_token"],
            user_id: userId,
        };
    } catch (error) {
        console.error("Error during login:", error);
        throw error;
    }
}

export {
    loginUser
};
